import React from "react";
import MxRushSwitchField, {
  MxRushSwitchFieldProps
} from "@rf-l1/form/rush-field/MxRushSwitchField";
import { useMxFieldControllerContext } from "@rf/context/MxFieldController";

type omit = "error" | "onBlur" | "onChange" | "id" | "value" | "testId" | "name";

export type MxFormRushSwitchFieldProps = Omit<MxRushSwitchFieldProps, omit>
const MxFormRushSwitchField = (props: MxFormRushSwitchFieldProps) => {
  const { id, invalid, name, onBlur, onChange, value } =
    useMxFieldControllerContext();

  return (
    <MxRushSwitchField
      {...props}
      id={id}
      onChange={onChange}
      onBlur={onBlur}
      value={value}
      name={name}
      error={invalid}
    />
  );
};

export default MxFormRushSwitchField;
